export default __webpack_public_path__ + "static/media/gallery01.c63fd544.webp";